<template>
  <span style="flex: 0 0 auto">
    <div class="text-center white--text">{{ projectsName }}</div>
    <canvas :id="'canvas' + projectId"></canvas>
  </span>
</template>

<script>
import QRCode from "qrcode";

export default {
  props: {
    projectId: {
      default: null,
    },
    projectsName: {
      default: null,
    },
  },
  mounted() {
    // this.generateQrCode();
    this.QrImgIcon();
  },
  methods: {
    generateQrCode() {
      if (this.projectId) {
        var link =
          process.env.VUE_APP_REDIRECTURI + `/projects/${this.projectId}`;

        var canvas = document.getElementById(`canvas${this.projectId}`);
        QRCode.toCanvas(canvas, link, { version: 5, margin: 1 });
      }
    },
    QrImgIcon() {
      const cWidth = 156;
      const cHeight = 156;
      const qrSize = 156;
      const btSize = 70;

      var canvas = document.getElementById(`canvas${this.projectId}`);
      var ctx = canvas.getContext("2d");
      ctx.canvas.height = cHeight.toString();
      ctx.canvas.width = cWidth.toString();
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, cWidth, cHeight);

      const url =
        process.env.VUE_APP_REDIRECTURI + `/projects/${this.projectId}`;

      QRCode.toDataURL(url, {
        errorCorrectionLevel: "H",
        version: 6,
        margin: 1,
        width: cWidth,
        color: {
          dark: "#000000",
          light: "#ffffff",
        },
      }).then((url) => {
        let img = new Image();
        img.src = url;

        img.onload = function () {
          var center = (cWidth - qrSize - 2) / 2;

          ctx.drawImage(img, center, 0, qrSize, qrSize);

          let btImg = new Image();
          btImg.src = "/img/icons/android-chrome-maskable-512x512.png";

          btImg.onload = function () {
            var center = (cWidth - btSize + 0 - 2) / 2;
            var center3 = (cWidth - btSize - 2) / 2;
            ctx.drawImage(btImg, center, center3, btSize, btSize);
          };
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
canvas {
  padding-left: 0;
  padding-right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 156px;
}
</style>
